<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <div class="c_group">
          <query-form
            class="content_block"
            label-width="90px"
            size="small"
            label-position="right"
            @search="getList('init')"
            @reset="handleReset"
            :keepOpenedRow="2">
            <el-form-item label="发货状态" :span="24">
              <check-tag v-model="advancedForm.status" @change="() => getList('init')">
                <check-tag-item
                  :value="i.en"
                  :key="i.en"
                  v-for="i in executionStatusGroup"
                  :label="`${i.label}${'(' + (i.count || 0) + ')'}`"
                ></check-tag-item>
              </check-tag>
            </el-form-item>
            <el-form-item label="订单编号">
              <el-input
                v-model.trim="advancedForm.code"
                clearable
                placeholder="请输入订单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品信息">
              <el-input
                v-model.trim="advancedForm.goodsNameOrSkuCodeOrOutSkuCode"
                clearable
                placeholder="请输入商品名称/编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人">
              <el-input
                v-model.trim="advancedForm.receiverName"
                clearable
                placeholder="请输入收货人"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人手机">
              <el-input
                v-model.trim="advancedForm.receiverPhone"
                clearable
                placeholder="请输入收货人手机"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否医疗件">
              <el-select v-model.trim="advancedForm.medicalFlag" clearable placeholder="请选择" @change="getList('init')">
                <el-option label="全部" :value="null"></el-option>
                <el-option label="医疗件" :value="true"></el-option>
                <el-option label="非医疗件" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流填单">
              <el-select v-model.trim="advancedForm.logisticsFillType" clearable placeholder="请选择" @change="getList('init')">
                <el-option label="全部" value=""></el-option>
                <el-option label="未确认" :value="1"></el-option>
                <el-option label="线下填单" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户抬头">
              <el-input
                v-model.trim="advancedForm.customerName"
                clearable
                placeholder="请输入客户抬头"
              ></el-input>
            </el-form-item>
          </query-form>
        </div>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table
            ref="xzTable"
            :columns="columnList"
            :data="dataList"
            :toolsAttrs="toolsAttrs"
            :scroll="{ x: '100%', y: scrollHeight }"
            rowKey="id"
            @refresh="handleReset"
            @fullScreen="handleFullScreen">
            <template #buttons>
              <el-button :disabled="!selectedAllLists.length" @click="handleBatchFillOrder" type="primary" size="mini">线下填单
                <el-tooltip class="item" effect="dark" content="批量录入已在线下完成物流寄件，未录入单号的订单" placement="right">
                  <i class="el-icon-warning-outline" style="font-size: 14px;"></i>
                </el-tooltip>
              </el-button>
              <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="orderShip" :disabledList="disabledList" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <template slot="imageList" slot-scope="image">
              <span v-if="image && image.split(',').length > 0">
                <span v-for="(img, i) in image.split(',')" :key="'img-'+i">
                  <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="image.split(',')" />
                </span>
                <span v-if="image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
              </span>
              <span v-else>暂无图片</span>
            </template>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination
        :current="pagination.pageNum"
        :total="total"
        :show-total="total => `共 ${total || 0} 条`"
        show-size-changer
        :pageSizeOptions="['10', '20', '30', '50', '100']"
        show-quick-jumper
        :pageSize.sync="pagination.pageSize"
        @change="handleNumChange"
        @showSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import { queryPage, querySaleOrderCount, exportOrderDelivery } from '@/api/pickUpOrders';
import { tenantDetail } from '@/api/shop';
import setTableCols from './configs';

const executionStatusGroup = [
  {
    label: '全部',
    value: '',
    en: 'allCount',
    count: 0,
  },
  {
    label: '待发货',
    value: '1',
    en: 'waitDeliveryCount',
    count: 0,
  },
  {
    label: '部分发货',
    value: '2',
    en: 'partDeliveryCount',
    count: 0,
  },
  {
    label: '已发货',
    value: '3',
    en: 'allDeliveryCount',
    count: 0,
  },
];

export default {
  name: 'OrderShip',
  components: {
    xzTable,
    tableHeaderConfiguration,
  },
  data () {
    return {
      userInfo: {},
      showUpdateDelivery: false,
      Moment,
      disabledList: [],
      dataList: [],
      advancedForm: {
        status: 'allCount',
        code: '',
        goodsNameOrSkuCodeOrOutSkuCode: '',
        receiverName: '',
        receiverPhone: '',
        medicalFlag: null,
        logisticsFillType: '',
        customerName: '',
        orderByProperty: '',
        orderByType: '',
      },
      executionStatusGroup,
      scrollHeight: 'calc(100vh - 400px)',
      columnList: [
        ...setTableCols.call(this),
      ],
      baseLists: [
        ...setTableCols.call(this),
      ],
      isFullScreen: false,
      total: 0,
      pagination: {
        pageNum: 1,
        pageSize: 10,
      },
      pageSupportSelectCount: 0, // 当前列表支持选中数量
      pageSelectedLists: [], // 当前列表已选中数据
      selectedAllKeys: [], // 全选选中数据id
      selectedAllLists: [], // 全选选中数据
    };
  },
  watch: {
    // 监听路由变化
    $route: function () {
      if (localStorage.getItem('refresh')) {
        localStorage.removeItem('refresh');
        this.getList('init');
        this.getSaleContractCount();
      }
    },
  },
  async created () {
    this.userInfo = this.$local.get('userInfo') ? JSON.parse(this.$local.get('userInfo')) : {};
    const { body } = await tenantDetail({
      id: this.userInfo.tenantId,
      findActivateServiceFlag: true,
    });
    if (body.activateService && body.activateService.includes('小紫VIS')) {
      this.showUpdateDelivery = true;
    }
    if (this.$route.query?.status === 'waitDeliveryCount') {
      this.advancedForm.status = 'waitDeliveryCount';
    }
    this.getList('init');
    this.getSaleContractCount();
  },
  computed: {
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        custom: true,
      };
    },
    indeterminate () {
      return (this.pageSelectedLists.length && this.pageSelectedLists.length !== this.pageSupportSelectCount) || false;
    },
    checkedAll () {
      return (this.pageSelectedLists.length && this.pageSelectedLists.length === this.pageSupportSelectCount) || false;
    },
    disabledAll () {
      return this.dataList.every(item => !(item.status === 3 && [1, 2].includes(item.deliveryStatus)));
    },
  },
  methods: {
    updateColumnList (columnList) {
      this.columnList = [
        {
          // title: '全选',
          dataIndex: 'selection',
          key: 'selection',
          fixed: 'left',
          width: 60,
          title: () => {
            const h = this.$createElement;
            return h('a-checkbox', {
              attrs: {
                indeterminate: this.indeterminate,
                checked: this.checkedAll,
                disabled: this.disabledAll,
              },
              on: {
                change: (e) => {
                  this.handleSelectAll(e.target.checked);
                },
              },
            });
          },
          customRender: (text, row) => {
            const h = this.$createElement;
            const obj = {
              children: h('a-checkbox', {
                attrs: {
                  disabled: !(row.status === 3 && [1, 2].includes(row.deliveryStatus)),
                  checked: row.checked,
                },
                on: {
                  change: (e) => {
                    this.handleSelect(row, e.target.checked);
                  },
                },
              }),
              attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
            };
            return obj;
          },
        },
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
          customRender: (text, row) => {
            const obj = {
              children: row.status === 3 && [1, 2].includes(row.deliveryStatus) && this.$withPermission('gongxutong:sale:order:delivery')
                ? <a style="margin-left: 8px" onClick={this.handleShip.bind(this, row)}>发货</a>
                : '',
              attrs: row.rowSpan ? { rowSpan: row.rowSpan } : { rowSpan: 0 },
            };
            return obj;
          },
        },
      ];
    },
    handleFullScreen () {
      this.isFullScreen = !this.isFullScreen;
    },
    handleSelectAll (isChecked) {
      this.dataList.map(item => {
        item.status === 3 && [1, 2].includes(item.deliveryStatus) && item.rowSpan && (item.checked = isChecked);
      });
      if (isChecked) { // 全选
        const pageSelectedKeys = this.dataList.filter(item => item.checked).map(item => item.id) || [];
        this.selectedAllKeys = this.selectedAllKeys.concat(pageSelectedKeys);
      } else { // 取消全选
        this.dataList.map(item => {
          item.checked = isChecked;
        });
        const pageKeys = this.dataList.map(item => item.id);
        this.selectedAllKeys = this.selectedAllKeys.filter(id => !pageKeys.includes(id));
      }
      this.getAllSelected();
    },
    handleSelect (row, isChecked) {
      if (isChecked) {
        this.selectedAllKeys.push(row.id);
      } else {
        const index = this.selectedAllKeys.indexOf(row.id);
        if (index !== -1) {
          this.selectedAllKeys.splice(index, 1);
        }
      }
      // 找到id对应的第一行
      const i = this.dataList.findIndex(item => item.id === row.id);
      if (i !== -1) {
        this.$set(this.dataList[i], 'checked', isChecked);
      }
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
      this.getAllSelected();
    },
    getAllSelected () {
      this.selectedAllKeys = [...new Set(this.selectedAllKeys)]; // 去重
      this.pageSelectedLists = this.dataList.filter(item => item.checked) || [];
      this.selectedAllLists = this.selectedAllLists.concat(this.pageSelectedLists).filter(item => this.selectedAllKeys.includes(item.id));

      // 数组对象去重
      let map = new Map();
      for (let item of this.selectedAllLists) {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      }
      this.selectedAllLists = [...map.values()];
    },
    handleSizeChange (_, size) {
      this.pagination.pageSize = size;
      this.getList();
    },
    handleNumChange (num) {
      this.pagination.pageNum = num;
      this.getList();
    },
    async handleExport () {
      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];
      const params = { tenantId: this.userInfo.tenantId, ...this.advancedForm, ...this.getOrderStatus(), orderBy, pageSize, pageNum, excludeStatuses: [2, 4, 6], findOrderGoodsFlag: true, findOrderGoodsDeliveredQuantityFlag: true };
      exportOrderDelivery(params).then(({data})=>{
        const downloadData = {
          data: data,
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          fileTitle: `订单发货_${Date.now()}`,
        };
        this.downBinaryStreamHandle(downloadData);
      });
    },
    downBinaryStreamHandle ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleReset () {
      for (let key in this.advancedForm) {
        this.advancedForm[key] = '';
      }

      this.getList('init');
    },
    getOrderStatus () {
      // 处理订单状态选中
      const statusOption = {
        status: '',
        deliveryStatus: '',
      };

      if (this.advancedForm.status === 'allCount') {
        statusOption.status = '';
        statusOption.deliveryStatus = '';
      } else if (this.advancedForm.status) {
        const deliveryStatusEn = ['waitDeliveryCount', 'partDeliveryCount', 'allDeliveryCount'];
        if (deliveryStatusEn.includes(this.advancedForm.status)) {
          const statusObj = this.executionStatusGroup.find(item => item.en === this.advancedForm.status);
          statusOption.deliveryStatus = statusObj?.value || '';
          statusOption.status = '';
          if (statusOption.deliveryStatus === '1') {
            statusOption.status = '3';
          }
        }
      }
      return statusOption;
    },
    getList (type) {
      this.pageSupportSelectCount = 0;
      if (type === 'init') {
        this.pageSelectedLists = [];
        this.selectedAllKeys = [];
        this.selectedAllLists = [];

        this.total = 0;
        this.pagination = {
          pageNum: 1,
          pageSize: 10,
        };
      }

      let { pageSize, pageNum } = this.pagination;
      let orderBy = [
        {
          orderByProperty: 'lastUpdateTime',
          orderByType: 'DESC',
        },
      ];

      const params = { ...this.advancedForm, ...this.getOrderStatus(), orderBy, pageSize, pageNum, excludeStatuses: [2, 4, 6], findOrderGoodsFlag: true, findOrderGoodsSerialFlag: true, findOrderGoodsDeliveredQuantityFlag: true };
      queryPage(params).then(
        ({body}) => {
          let list = [];
          (body.list || []).forEach(item => {
            (item.orderGoodsList || []).forEach((goods, index) => {
              list.push({
                ...item,
                ...goods,
                id: `${item.id}-${index}`,
                rowSpan: index === 0 ? item.orderGoodsList.length : null,
                checked: this.selectedAllKeys.includes(`${item.id}-${index}`) || false,
              });

              // 统计未合并且未发货的订单数
              if (index === 0 && item.status === 3 && [1, 2].includes(item.deliveryStatus)) {
                this.pageSupportSelectCount += 1;
              }
            });
          });
          this.dataList = list;
          // 筛选当前页选中的商品
          this.pageSelectedLists = this.dataList.filter(item => item.checked);

          this.total = +body.total || 0;
        },
      );
    },
    getSaleContractCount () {
      querySaleOrderCount().then(({ body }) => {
        const allCount = body.waitDeliveryCount + body.partDeliveryCount + body.allDeliveryCount;
        for (let v of this.executionStatusGroup) {
          v.count = body[v.en];
          if (v.en === 'allCount') {
            v.count = allCount;
          }
        }
      });
    },
    handleBatchFillOrder () {
      // 本地保存选择的订单信息
      const selectedAllKeys = this.selectedAllKeys.map(item => item.split('-')[0]);
      const _selectedAllLists = JSON.parse(JSON.stringify(this.selectedAllLists));
      const selectedAllLists = _selectedAllLists.map(item => {
        item.id = item.id.split('-')[0];
        return item;
      });
      // 过滤出 orderGoodsList 中 unDeliveredQuantity 大于0的商品
      const filteredSelectedAllLists = selectedAllLists.map(item => {
        item.orderGoodsList = item.orderGoodsList.filter(goods => goods.unDeliveredQuantity > 0);
        item.orderGoodsList.map(goods => {
          goods.quantity = goods.unDeliveredQuantity;
        });
        return item;
      });
      localStorage.setItem('selectedAllKeys', JSON.stringify(selectedAllKeys));
      localStorage.setItem('selectedAllLists', JSON.stringify(filteredSelectedAllLists));
      this.$router.push({
        path: `/salesManagement/OrderShip/fill?timestamp=${new Date().getTime()}`,
      });
    },
    handleShip (row) {
      const path = '/salesManagement/pickUpOrders/ship';

      this.$router.push({
        path,
        query: {
          id: row.id.split('-')[0],
          orderCode: row.code,
          outOrderId: row.outOrderId,
          dockingSystem: row.dockingSystem,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}
.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .c_group {
        position: relative;

        .content_block {
          border-bottom: 0.5px solid #DFE2E8;
          padding: 10px;
        }

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #f2f4f7;

          &.active-radio {
            border-color: #e2f3fe;
            background-color: #e2f3fe;
            color: #237ffa;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #c9ced6;
  background: #c9ced6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #c9ced6;
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
